const carouselItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20aesthetic%20with%20futuristic%20cityscape%20and%20golden%20sunset%20tones%2C%20cinematic%20composition%2C%20film%20poster%20style%2C%20warm%20amber%20and%20dark%20blue%20contrast%2C%20epic%20scale%2C%20professional%20movie%20visual&width=600&height=380&seq=carousel-01&orientation=landscape',
    title: '科幻巨制专场',
    desc: '从《沙丘》到《星际穿越》，经典与新作一次看够',
    tag: '热门专题',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Classic%20black%20and%20white%20film%20aesthetic%20with%20vintage%20movie%20camera%20and%20old%20Hollywood%20glamour%2C%20warm%20sepia%20tones%2C%20nostalgic%20cinema%20atmosphere%2C%20elegant%20composition%2C%20film%20history%20vibe&width=600&height=380&seq=carousel-02&orientation=landscape',
    title: '经典修复重映',
    desc: '影史不朽之作4K修复版高清上线，重温光影魅力',
    tag: '经典回顾',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Asian%20cinema%20aesthetic%20with%20warm%20lantern%20lighting%2C%20martial%20arts%20silhouette%20against%20misty%20mountain%2C%20cinematic%20mood%2C%20golden%20and%20red%20accents%2C%20elegant%20film%20composition%2C%20dramatic%20atmosphere&width=600&height=380&seq=carousel-03&orientation=landscape',
    title: '华语电影精选',
    desc: '从港片黄金时代到新生代导演力作，华语光影之旅',
    tag: '专题聚焦',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Animated%20film%20aesthetic%20with%20colorful%20magical%20atmosphere%2C%20dreamy%20golden%20light%20particles%2C%20cinematic%20composition%2C%20warm%20and%20vibrant%20tones%2C%20storytelling%20visual%2C%20enchanting%20movie%20scene&width=600&height=380&seq=carousel-04&orientation=landscape',
    title: '动画电影盛宴',
    desc: '从宫崎骏到皮克斯，动画世界的奇幻旅程等你探索',
    tag: '合家欢',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20aesthetic%20with%20dark%20rainy%20street%20and%20warm%20neon%20light%20reflections%2C%20film%20noir%20style%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20dramatic%20shadows%2C%20professional%20movie%20visual&width=600&height=380&seq=carousel-05&orientation=landscape',
    title: '悬疑烧脑合集',
    desc: '高智商反转剧情，每一帧都让人屏住呼吸的精彩',
    tag: '烧脑推荐',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Documentary%20film%20aesthetic%20with%20natural%20landscape%20and%20warm%20golden%20hour%20lighting%2C%20cinematic%20realism%2C%20storytelling%20visual%2C%20earth%20tones%20palette%2C%20professional%20nature%20photography%20style%2C%20immersive%20atmosphere&width=600&height=380&seq=carousel-06&orientation=landscape',
    title: '纪录佳作展映',
    desc: '真实世界的精彩故事，每一部都值得静心观看',
    tag: '深度纪实',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            专题聚焦
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精心策划的六大专题，带你发现不同维度的电影世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="bg-background-200/60 rounded-lg overflow-hidden border border-background-300/30 hover:border-primary-500/20 transition-all duration-200 group cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.display = 'none';
                    }
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <span className="text-xs bg-primary-500 text-background-950 font-semibold px-2.5 py-1 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-200 mb-2 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}